import api from './api';
import {
  TTIApplicationKeyCreate,
  TTIApplicationKeyUpdate,
  TTIApplicationKey,
  TTIApplicationKeyListResponse,
  TTIApplicationKeyVerifyResponse,
  TTIDeviceListResponse,
} from '../types';

export const ttiApplicationKeysService = {
  /**
   * List all TTI application keys.
   */
  async listApplicationKeys(): Promise<TTIApplicationKeyListResponse> {
    const response = await api.get<TTIApplicationKeyListResponse>('/api/tti-application-keys/');
    return response.data;
  },

  /**
   * Create a new TTI application key.
   */
  async createApplicationKey(data: TTIApplicationKeyCreate): Promise<TTIApplicationKey> {
    const response = await api.post<TTIApplicationKey>('/api/tti-application-keys/', data);
    return response.data;
  },

  /**
   * Get a specific TTI application key.
   */
  async getApplicationKey(keyId: number): Promise<TTIApplicationKey> {
    const response = await api.get<TTIApplicationKey>(`/api/tti-application-keys/${keyId}`);
    return response.data;
  },

  /**
   * Update a TTI application key.
   */
  async updateApplicationKey(keyId: number, data: TTIApplicationKeyUpdate): Promise<TTIApplicationKey> {
    const response = await api.put<TTIApplicationKey>(`/api/tti-application-keys/${keyId}`, data);
    return response.data;
  },

  /**
   * Delete a TTI application key.
   */
  async deleteApplicationKey(keyId: number): Promise<{ message: string }> {
    const response = await api.delete<{ message: string }>(`/api/tti-application-keys/${keyId}`);
    return response.data;
  },

  /**
   * Verify a TTI application key.
   */
  async verifyApplicationKey(keyId: number): Promise<TTIApplicationKeyVerifyResponse> {
    const response = await api.post<TTIApplicationKeyVerifyResponse>(`/api/tti-application-keys/${keyId}/verify`);
    return response.data;
  },

  /**
   * List devices for a specific TTI application.
   */
  async listDevicesForApplication(keyId: number): Promise<TTIDeviceListResponse> {
    const response = await api.get<TTIDeviceListResponse>(`/api/tti-application-keys/${keyId}/devices`);
    return response.data;
  },
};
